module.exports = __webpack_public_path__ + "img/1978-850x510-the-piano-player.a685bbd7.jpg";